import React from 'react';
import { useCouponList } from '../../../hooks/coupon/useCouponList';
import { CouponListSearchBox } from './CouponListSearchBox';
import { CouponList } from './CouponList';
import { CouponListWrapStyle } from './style';

export const CouponListWrap = () => {
  const {
    couponList,
    totalCount,
    filterOption,
    sortOption,
    pagination,
    searchData,
    onFilter,
    onSort,
    onPageChange,
    onSearch,
    onClear,
    onSearchDataChange,
    onExcelDownload,
  } = useCouponList();

  return (
    <CouponListWrapStyle className="coupon-list-wrap">
      <CouponListSearchBox
        searchData={searchData}
        onSearch={onSearch}
        onClear={onClear}
        onSearchDataChange={onSearchDataChange}
      />

      <CouponList
        list={couponList}
        totalCount={totalCount}
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        onFilter={onFilter}
        onSort={onSort}
        onPageChange={onPageChange}
        onExcelDownload={onExcelDownload}
      />
    </CouponListWrapStyle>
  );
};
